declare global {
    interface RouterMeta {
        title: string;
    }
    interface Router {
        path: string;
        name: string;
        icon?: string;
        permission?: string;
        meta?: RouterMeta;
        component: any;
        children?: Array<Router>;
    }
    interface System {
        import(request: string): Promise<any>
    }
    var System: System
}
import login from '../views/login.vue'
import home from '../views/home/home.vue'
import main from '../views/main.vue'

export const locking = {
    path: '/locking',
    name: 'locking',
    component: () => import('../components/lockscreen/components/locking-page.vue')
};
export const loginRouter: Router = {
    path: '/',
    name: 'login',
    meta: {
        title: 'LogIn'
    },
    component: () => import('../views/login.vue')
};
export const otherRouters: Router = {
    path: '/main',
    name: 'main',
    permission: '',
    meta: { title: 'ManageMenu' },
    component: main,
    children: [
        { path: 'home', meta: { title: 'HomePage' }, name: 'home', component: () => import('../views/home/home.vue') },
        { path: 'userprofile', meta: { title: 'UserProfile' }, name: 'userprofile', component: () => import('../views/setting/profile/userprofile.vue') }
    ]
}
export const appRouters: Array<Router> = [
    {
        path: '/meeting',
        name: 'meeting',
        permission: '',
        meta: { title: 'MeetingManage' },
        icon: 'ios-people-outline',
        component: main,
        children: [
            { path: 'appointment', permission: 'Pages.Appointment', meta: { title: 'MeetingAppointment' }, name: 'appointment', component: () => import('../views/meeting/appointment.vue') },
            { path: 'approval', permission: 'Pages.Approval', meta: { title: 'MeetingApproval' }, name: 'approval', component: () => import('../views/meeting/approval.vue') },
            { path: 'manage', permission: 'Pages.Manage', meta: { title: 'MeetingManage' }, name: 'manage', component: () => import('../views/meeting/manage.vue') },
            { path: 'information', permission: 'Pages.Information', meta: { title: 'MeetingInformation' }, name: 'information', component: () => import('../views/meeting/information.vue') },
            { path: 'scheme', permission: 'Pages.Scheme', meta: { title: 'MeetingScheme' }, name: 'scheme', component: () => import('../views/meeting/scheme.vue') }
        ]
    },
    {
        path: '/room',
        name: 'room',
        permission: '',
        meta: { title: 'MeetingRoomManage' },
        icon: 'ios-easel-outline',
        component: main,
        children: [
            { path: 'office', permission: 'Pages.Office', meta: { title: 'MeetingOffice' }, name: 'office', component: () => import('../views/room/office.vue') },
            { path: 'device', permission: 'Pages.Device', meta: { title: 'MeetingDevice' }, name: 'device', component: () => import('../views/room/device.vue') },
            { path: 'scene', permission: 'Pages.Scene', meta: { title: 'MeetingScene' }, name: 'scene', component: () => import('../views/room/scene.vue') }            
        ]
    },
    {
    path: '/setting',
    name: 'setting',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: 'ios-settings-outline',
    component: main,
    children: [
        { path: 'user', permission: 'Pages.Users', meta: { title: 'Users' }, name: 'user', component: () => import('../views/setting/user/user.vue') },
        { path: 'role', permission: 'Pages.Roles', meta: { title: 'Roles' }, name: 'role', component: () => import('../views/setting/role/role.vue') },
        { path: 'tenant', permission: 'Pages.Tenants', meta: { title: 'Tenants' }, name: 'tenant', component: () => import('../views/setting/tenant/tenant.vue') }
    ]
}]
export const routers = [
    loginRouter,
    locking,
    ...appRouters,
    otherRouters
];
